// Only observed device data supplies the maintenance rollback baseline.
export const getMaintenanceState = (device, previousStatus = 0) => {
  const status = Number(device?.data?.[0]?.status ?? 0);
  return {
    killSwitch: device?.kill_switch ?? 0,
    status,
    previousStatus: status === -1 ? previousStatus : status,
  };
};

export const applyMaintenanceState = (device, maintenance) => {
  const [firstEntry, ...restEntries] = Array.isArray(device.data) ? device.data : [];
  return {
    ...device,
    kill_switch: maintenance.killSwitch,
    data: [{ ...firstEntry, status: maintenance.status }, ...restEntries],
  };
};

export const hasMaintenanceStateChanged = (previousDevice, device) => {
  const wasMaintenanceActive =
    Boolean(previousDevice.kill_switch) || Number(previousDevice.data?.[0]?.status) === -1;
  const isMaintenanceActive =
    Boolean(device.kill_switch) || Number(device.data?.[0]?.status) === -1;
  return (
    previousDevice.id !== device.id ||
    previousDevice.kill_switch !== device.kill_switch ||
    wasMaintenanceActive !== isMaintenanceActive
  );
};

export const getMaintenanceStateWithStatus = (maintenanceState, previousStatus) => ({
  ...maintenanceState,
  previousStatus,
  status: maintenanceState.status === -1 ? -1 : previousStatus,
});

export const canSendDeviceCommands = (device, perms) => {
  const systemType = `${device?.system_type || ''}`.replace(/\s/g, '');
  const deviceType = `${device?.device_type || ''}`.replace(/\s/g, '').replace(/\//g, '-');

  if (!systemType || !deviceType) return false;

  // Command permission is separate from permission to edit the device connection.
  return perms.testPermission([], ['SendDeviceCommands']);
};
